
export class TextSearch {

    static toFieldNameFormat(arg0: string): string {
        return this.retirarAcentos(arg0).replace('/', '-');
    }

    public static lowerAll(str) {
        const x = ',de,para,ate,a,e,ou,das,dos,ao,aos,o,em,';
        return this.retirarAcentos(',' + x + ',').indexOf(str) >= 0;
    }
    public static lowerAcentuados(str) {
        const com_acento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞß';
        const sem_acento = 'àáâãaaaçeéêeiíîidnoóôõoouúûuyrsb';
        let novastr = '';
        for (let i = 0; i < str.length; i++) {
            let troca = false;
            for (let a = 0; a < com_acento.length; a++) {
                // tslint:disable-next-line:triple-equals
                if (str.substr(i, 1) == com_acento.substr(a, 1)) {
                    novastr += sem_acento.substr(a, 1);
                    troca = true;
                    break;
                }
            }
            // tslint:disable-next-line:triple-equals
            if (troca == false) {
                novastr += str.substr(i, 1);
            }
        }
        return novastr;
    }

    public static upperCapital(x) {
        if (!x) { return ''; }
        let names = [], rt = '';
        names = x.split(' ');
        // tslint:disable-next-line:triple-equals
        if (names.length == 0) { rt = x; }
        // se já existir uma minuscula, nao fazer nada
        let achei = false;
        for (let i = 0; i < x.length; i++) {
            const element = x[i];
            const l = element.toLowerCase(), u = element.toUpperCase();
            // tslint:disable-next-line:triple-equals
            if (l != u && l == element) {
                achei = true;
            }
        }
        // if (achei) console.log('achei',x);
        if (achei) { return x; }

        // trocar cada palavra
        names.forEach(element => {
            if (this.lowerAll(element)) {
                rt += element.toLowerCase() + ' ';
            } else
                if (element.length > 1) {
                    const c1: string = element.substring(0, 1),
                        c2: string = this.lowerAcentuados(element.substring(1, 255));
                    // tslint:disable-next-line:triple-equals
                    if (c1.toLowerCase() != c1 && c2.toLowerCase() != c2) {
                        rt += c1.toUpperCase() + c2.toLowerCase() + ' ';
                    } else { rt += element + ' '; }
                }
        });
        // console.log(rt);
        return rt.trim();
    }


    public static retirarAcentos(str) {
        const com_acento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ';
        const sem_acento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr';
        let novastr = '';
        for (let i = 0; i < str.length; i++) {
            let troca = false;
            for (let a = 0; a < com_acento.length; a++) {
                if (str.substr(i, 1) === com_acento.substr(a, 1)) {
                    novastr += sem_acento.substr(a, 1);
                    troca = true;
                    break;
                }
            }
            if (troca === false) {
                novastr += str.substr(i, 1);
            }
        }
        return novastr;
    }
    public static acepted(text: string) {
        return ((text !== 'undefined') && (text > '') && (text.length > 1));
    }
    public static clear(text: string): string {
        let r, s = '';
        if (text != null) {
            r = text.match(/[a-zA-Z0-9]/gi);
            if (r) {
                s = '';
                r.forEach(element => {
                    s += element;
                });
            }
            if (s.replace(/[0-9]/gi, '') === '') { s = ''; }// se for tudo numero não pode
        }
        return (r ? this.retirarAcentos(s) : '');
    }
    public static filtered(text: string, ignore: Array<string>) {
        const rt = '';
        let ignorar: string = null;
        const p = ['de', 'para', 'do', 'ate', 'da'];
        const tx: string = this.clear(text);
        if (tx.length > 0) {
            p.forEach(element => {
                if ((ignorar == null) && (element === tx)) {
                    ignorar = tx;
                }
            });
        }
        if (ignorar == null) { return tx; } else { return ''; }
    }
    public static decode(text) {
        const r = {};
        const splitted = this.retirarAcentos(text).split(' ', 50);
        splitted.forEach(element => {
            const tmp = element.toLowerCase();
            const s = String(this.filtered(tmp, [])).replace('/', '-');
            if (s && this.acepted(s)) {
                r[s] = true;
            }
        });
        return r;
    }

    public static keys(x: any = {}) {
        return x.keys;
    }

    public static encodeWhere(w: any, path: string = 'search', text: string) {
        const r = {};
        let query;
        const splitted = text.split(' ', 50);
        splitted.forEach(element => {
            const tmp = this.clear(element.toLowerCase());
            const s = String(this.filtered(tmp, [])).replace('/', '-');
            if (s && this.acepted(s)) {
                const v = path + s;
                query = w.where(String(v), '==', true);
                return w;
            }
        });
        return query;
    }
}
